/*
 * @Author: yanghailong
 * @Date: 2025-01-06 09:25:11
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-10 16:36:20
 */
import Konva from "konva"
import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help.js"


class GroundElement extends GraphElement {
  static _createFunc = createFromJSON(this)
  static async fromJSON(topology, node, complete) {
    const elem = await this._createFunc(topology, node, complete)
    elem.setSwitch(node.switchValue)
    return elem
  }
  constructor(topology, x, y, attrs) {
    super(topology, 'ground', x, y, {
      text: '接地',
      port: true,
      useTransparentImg: true,
      ...attrs
    })

    // 开关状态: true: 闭合 false: 断开
    this.switchValue = false
    this.shapes = []
    this.color = '#3BB74F'

    this.onLoad(() => {
      // 不需要显示名称
      this.label.visible(false)
      this.addShapes()
    })
  }


  addShapes() {

    // 中间横线的位置
    const left = this.width / 2

    if (this.switchValue) {
      this.vline = new Konva.Line({
        points: [left, 0, left, 30],
        stroke: this.color,
        strokeWidth: 2,
      })
      this.g.add(this.vline)
      this.shapes.push(this.vline)
    }

    else {
      this.vline1 = new Konva.Line({
        points: [left, 0, left, 10],
        stroke: this.color,
        strokeWidth: 2,
      })
      this.vline2 = new Konva.Line({
        points: [left, 18, left, 32],
        stroke: this.color,
        strokeWidth: 2,
      })
      this.vline3 = new Konva.Line({
        points: [left, 18, left + 10, 12],
        stroke: this.color,
        strokeWidth: 2,
      })

      this.g.add(this.vline1)
      this.g.add(this.vline2)
      this.g.add(this.vline3)

      this.shapes.push(this.vline1)
      this.shapes.push(this.vline2)
      this.shapes.push(this.vline3)
    }


    // 三条横线离顶部的距离
    const offsetY = 26
    // 三条横线
    for (let i = 1; i <= 3; i++) {
      const width = (4 - i) * 6 + 8
      let rect = new Konva.Rect({
        x: (this.width - width) / 2,
        y: i * 5 + offsetY,
        width: width,
        height: 2,
        fill: this.color,
      })


      this.g.add(rect)
    }

  }

  removeShapes() {
    this.shapes.forEach(shape => {
      shape.remove()
    })
    this.shapes = []
  }


  updateShapes() {
    this.removeShapes()
    this.color = this.switchValue ? '#F73046' : '#3BB74F'
    this.addShapes()
  }

  setSwitch(switchValue) {
    console.log('接地开关设置', switchValue)
    this.switchValue = switchValue

    this.updateShapes()
  }


  toJSON() {
    return {
      ...super.toJSON(),
      switchValue: this.switchValue,
    }

  }
}


export { GroundElement }
